(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vant"), require("vueCompositionApi"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vant", "vueCompositionApi", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["vantForm"] = factory(require("vant"), require("vueCompositionApi"), require("Vue"));
	else
		root["vantForm"] = factory(root["vant"], root["vueCompositionApi"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3089__, __WEBPACK_EXTERNAL_MODULE__8165__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 